(() => {
  const scope='.rte, rte-formatter, .page-content, .pb-product-description__content, .text-block';
  const apply=root=>{
    if(!root?.querySelectorAll)return;
    const nodes=[...(root.matches?.('[style]')?[root]:[]),...root.querySelectorAll('[style]')];
    nodes.forEach(node=>{
      if(!node.closest(scope)||node.closest('svg')||/icon|fa-/.test(node.className||''))return;
      if(node.style.fontFamily&&node.style.fontFamily!=='var(--font-body--family)')node.style.setProperty('font-family','var(--font-body--family)','important');
    });
  };
  apply(document);
  let pending=new Set(),queued=false;
  const observer=new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)pending.add(node)}));
    if(queued||!pending.size)return;queued=true;
    queueMicrotask(()=>{pending.forEach(apply);pending.clear();queued=false});
  });
  const main=document.querySelector('#MainContent');if(main)observer.observe(main,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event=>apply(event.target));
})();
